import Affix from 'antd/es/affix';
export default Affix;
